import {useNavigate, useLocation, NavLink} from "react-router-dom";
import {useEffect, useState} from "react";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";

export default function Sidebar({ mobileOpen, onClose }) {
    const [user, setUser] = useState(null);
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);

    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded);
    }, [cookies.token]);

    return (
        <>
            {/* Overlay mobile */}
            <div
                className={`sidebar-overlay ${mobileOpen ? "open" : ""}`}
                onClick={onClose}
            />
            <aside className={`sidebar ${mobileOpen ? "open" : ""}`}>
                <div className="sidebar-header">
                    PZ Admin
                    <button className="sidebar-close-btn" onClick={onClose}>✖</button>
                </div>

                <div className="nav-section">
                <div className="nav-section-title">Navigation</div>
                    <ul className="nav">
                        <li>
                            <NavLink to="/dashboard">
                                Dashboard
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/users">
                                Utilisateurs
                            </NavLink>
                        </li>

                        {/*<li><a>Commandes</a></li>*/}
                        {/*<li><a>Produits</a></li>*/}
                    </ul>
                </div>

                <div className="nav-section">
                    <div className="nav-section-title">Log Torrent</div>
                    <ul className="nav">
                        <li>
                            <NavLink to="/requests">
                                Requests
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/torrents">
                                Torrents
                            </NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-section">
                    <div className="nav-section-title">Bot Discord</div>
                    <ul className="nav">
                        <li>
                            <NavLink to="/bot-dashboard">
                                Dashboard
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/announce">
                                Announce
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/bot-presence">
                                Présence
                            </NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-section">
                    <div className="nav-section-title">Maison</div>
                    <ul className="nav">
                        <li>
                            <NavLink to="/garden">
                                Jardinage
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/recipe">
                                Recette
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/quebec">
                                Quebec
                            </NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-section">
                    <div className="nav-section-title">Paramètres</div>
                    <ul className="nav">
                        <li><NavLink to={`/profile/${user?.userId}`}>
                            Profil
                        </NavLink></li>
                        <li><a>Sécurité</a></li>
                    </ul>
                </div>

                <div className="sidebar-footer">Version 4.2A · Thème 1.2</div>
            </aside>
        </>
    );
}
